/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function FishSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M104.00858,54.63764C75.88186,75.1517,55.69935,115.413,63.9833,191.98326h0c76.58162,8.3037,116.85108-11.867,137.3707-39.98746l-.00709-.00518A96.0002,96.0002,0,0,1,104.00959,54.639Z"
        opacity={0.2}
      />
      <Circle cx={156} cy={76} r={12} />
      <Path
        d="M16,183.96316C247.8414,234.71183,223.79084,75.46765,217.18687,44.9601a8.01954,8.01954,0,0,0-6.147-6.147C180.5321,32.20917,21.28468,8.15854,72,240"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M201.34694,151.99061A96.0002,96.0002,0,0,1,104.00959,54.639"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default FishSimple;
